export default __webpack_public_path__ + "static/media/MAGDALENA.d72cce85.png";